<template>
  <modal-pro></modal-pro>
  <product-hero
    :bg="require('@/assets/banner-products.jpg')"
    code="<span class='colored'>VA</span>"
    :title="$t('products.vaTitle')"
  ></product-hero>
  <product-line-item
    v-for="(item, idx) in products"
    :key="idx"
    :img="item.img"
    :name="item.name"
    :tagline="item.tagline"
    :slug="item.slug"
  ></product-line-item>
</template>

<script>
import ProductHero from "./../../components/ProductHero.vue";
import ProductLineItem from "./../../components/ProductLineItem.vue";
import ModalPro from "./../../components/ModalPro.vue";
import productDetails from "./../../data/productDetails.js";

export default {
  name: "VA",
  components : { ProductHero, ProductLineItem, ModalPro },
  computed : {
    contentLocale() {
      return this.$store.state.region === "us" ? "us" : this.$i18n.locale;
    },
    products() {
      const items = [];

      if (this.$store.state.region !== "us") {
        items.push({
          img : productDetails.sycamore.icon || productDetails.sycamore.heroImg,
          name : productDetails.sycamore.name,
          tagline : this.$t("sycamore.tagline", this.contentLocale),
          slug : productDetails.sycamore.slug
        });
      }

      items.push({
        img : productDetails.kypho.icon || productDetails.kypho.heroImg,
        name : this.$t("kypho.title"),
        tagline : this.$t("kypho.tagline", this.contentLocale),
        slug : productDetails.kypho.slug
      });

      items.push({
        img : productDetails.cement.icon || productDetails.cement.heroImg,
        name : this.$t("cement.title"),
        tagline : this.$t("cement.tagline", this.contentLocale),
        slug : productDetails.cement.slug
      });

      return items;
    }
  }
}
</script>
